import { createContext } from 'react'

import { FilterData } from '~/lib/util/fe/filters'
import { CurrentCampaign } from '~/types/campaigns'
import { ProtectPageOption } from '~/types/roles'
import type { CurrentUser } from '~/types/users'

export interface AuthContextType {
  authorizedValues: {
    user: CurrentUser | null
    campaign: CurrentCampaign
    initialized: boolean
    memberCount: number
  }
  filterData: FilterData
  errorCodes: any[]
  protectPage: (
    initialized: boolean,
    user: any,
    options?: ProtectPageOption
  ) => void
  updateAuthorizedValues: () => void
  forceRefresh: () => void
  refreshFilterData: () => void
  showNavMenu: boolean
  updateFilterData: (campaignId) => void
  updateMemberCount: (campaignId) => void
  updateShowNavMenu: (show: boolean) => void
}

export const AuthContext = createContext<AuthContextType>({
  authorizedValues: {
    user: null,
    campaign: null,
    initialized: false,
    memberCount: null
  },
  protectPage: (initialized, user, options) => {},
  updateAuthorizedValues: () => {},
  forceRefresh: () => {},
  filterData: null,
  errorCodes: null,
  refreshFilterData: () => {},
  showNavMenu: false,
  updateFilterData: (campaignId) => {},
  updateMemberCount: (campaignId) => {},
  updateShowNavMenu: (show) => {}
})
